
import { createContext } from "react";

import { AuthenticateResponse } from "@/apis/dtos";
import { useAuthenticatedUser } from "@/hooks/auth/useAuthenticatedUser";

export interface IAuthContext extends Omit<ReturnType<typeof useAuthenticatedUser>, 'data' | 'total' | 'offset'> {
    data?: AuthenticateResponse;
}

export const AuthContext = createContext<IAuthContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default AuthContext;